import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DRangosArt241ET } from "@dian-api/renta210v18";
import {
  DBasicosParametricasServicios,
  DValorPeriodico,
} from "@dian/api-basicos-parametricas";
const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_548';

const VAL_PERIODICO_110 = 110;
const ANNIODECLARACION = 2022;
declare var require: (filename: string) => any;

var BigNumber210 = require("bignumber.js");

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Activos', listHelp: ['487'] }
];

const tableStructure = [
  {id: 'desc', title: 'Descripción'}, 
  {id: 'valVenta', title: 'Valor'},
  {id: 'ubicacion', title: 'Ubicación'}
];

class Form1 {
  id: number;
  desc: string; //descripcion
  valVenta: string; //valor venta
  valCompra: string; //valor compra
  anioCompra: string; //anio compra
  valImpuestoPag: string; //valor impuesto pagado exterior
  valMejoras:string; //valor mejoras
  ubicacion: number; //ubicacion accion
  impuestoCalcColombia:string // impuesto calculado en colombia
  limitanteImpuestoExterior: string //limitante impuesto
}

class ArticulosDominio {
  valor: number;
  nombre: string;
}

@Component({
  selector: 'app-renta-no-laboral-activos-modal',
  templateUrl: './renta-no-laboral-activos-modal.component.html',
  styleUrls: ['./renta-no-laboral-activos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio,
    DBasicosParametricasServicios,
  ]
})
export class RentaNoLaboralActivosModalComponent extends HandlerModal implements OnInit {
  saveModel = new EventEmitter();
  public showSave:boolean=false;
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public lstUbicaciones: ArticulosDominio[] = [];
  public lsValoresCostos: ArticulosDominio[] = [];
  public lsSiNo: ArticulosDominio[] = [];
  public lstAnios: ArticulosDominio[] = [];



  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;


  private rangosArt241ET: any;
  public UVT: string = "";
  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<RentaNoLaboralActivosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento,
    private dBasicosParametricasServicios: DBasicosParametricasServicios
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);

    console.log(model);
  }

  ngOnInit() {
    this.initializeArticulos();
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.validateShowSave();
    this.rangosArt241ET = DRangosArt241ET.NUMERAL_1;
    this.obtenerValorPeriodico110();
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.desc="";
    this.modelForm.valCompra="0";
    this.modelForm.anioCompra="0";
    this.modelForm.valVenta="0";
    this.modelForm.valImpuestoPag="0";
    this.modelForm.ubicacion=0;
    this.modelForm.valMejoras="0";
    this.modelForm.impuestoCalcColombia="0";
    this.modelForm.limitanteImpuestoExterior="0"


  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_904 == undefined){
      this.model.doc.cuerpo.cc_id_904 = [];
      this.model.doc.cuerpo.cc_id_905 = [];
      this.model.doc.cuerpo.cc_id_906 = [];
      this.model.doc.cuerpo.cc_id_907 = [];
      this.model.doc.cuerpo.cc_id_908 = [];
      this.model.doc.cuerpo.cc_id_909 = [];
      this.model.doc.cuerpo.cc_id_910 = [];
      this.model.doc.cuerpo.cc_id_911 = [];
      this.model.doc.cuerpo.cc_id_912 = [];

      this.model.doc.cuerpo.cs_id_488 = "0";
      this.model.doc.cuerpo.cs_id_489 = "0";
      this.model.doc.cuerpo.cs_id_663 = "0";




    }  
  }

  protected initializeArticulos(){
    this.lstArticulos[0] = {valor:1,nombre:"Valor Catastral"};
    this.lstArticulos[1] = {valor:2,nombre:"Valor Articulo 70"};
    this.lstArticulos[2] = {valor:3,nombre:"Valor Articulo 73"};

    this.lsValoresCostos[0] = {valor:1,nombre:"Valor 1"};
    this.lsValoresCostos[1] = {valor:2,nombre:"Valor 2"};
    this.lsValoresCostos[2] = {valor:3,nombre:"Valor 3"};

    this.lstUbicaciones[0] = {valor:1,nombre:"Nacional"};
    this.lstUbicaciones[1] = {valor:2,nombre:"Extranjero"};

    
    this.lsSiNo[0] = {valor:1,nombre:"Si"};
    this.lsSiNo[1] = {valor:2,nombre:"No"};

    this.lstAnios[0] = { valor: 2020, nombre: "2020" };
    this.lstAnios[1] = { valor: 2021, nombre: "2021" };
    this.lstAnios[2] = { valor: 2022, nombre: "2022" };
  }

  public operacionCs488(){
    let suma1 = "0";
    let suma2 = "0";
    let suma3 = "0";

    for(let i=0; i<this.dataSourceBody.length; i++){
      suma1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valVenta, suma1);
      suma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valCompra, suma2);
      suma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valMejoras, suma2);

      suma3 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].limitanteImpuestoExterior, suma3);

    }
    this.model.doc.cuerpo.cs_id_488 = suma1;
    this.model.doc.cuerpo.cs_id_489 = suma2;
    this.model.doc.cuerpo.cs_id_663 = suma3;

  }

  
  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_904.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_904[i].v;
      this.modelForm.valCompra=this.model.doc.cuerpo.cc_id_908[i].v;
      this.modelForm.valVenta=this.model.doc.cuerpo.cc_id_906[i].v;
      this.modelForm.anioCompra=this.model.doc.cuerpo.cc_id_907[i].v;
      this.modelForm.valImpuestoPag=this.model.doc.cuerpo.cc_id_910[i].v;
      this.modelForm.ubicacion=this.model.doc.cuerpo.cc_id_905[i].v;
      this.modelForm.valMejoras=this.model.doc.cuerpo.cc_id_909[i].v;


      this.modelForm.impuestoCalcColombia=this.model.doc.cuerpo.cc_id_911[i].v;
      this.modelForm.limitanteImpuestoExterior=this.model.doc.cuerpo.cc_id_912[i].v;


      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_904[this.modelForm.id].v=this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_905[this.modelForm.id].v=this.modelForm.ubicacion.toString();
    this.model.doc.cuerpo.cc_id_906[this.modelForm.id].v=this.modelForm.valVenta.toString();
    this.model.doc.cuerpo.cc_id_907[this.modelForm.id].v=this.modelForm.anioCompra.toString();
    this.model.doc.cuerpo.cc_id_908[this.modelForm.id].v=this.modelForm.valCompra.toString();
    this.model.doc.cuerpo.cc_id_909[this.modelForm.id].v=this.modelForm.valMejoras.toString();
    this.model.doc.cuerpo.cc_id_910[this.modelForm.id].v=this.modelForm.valImpuestoPag.toString();

    this.model.doc.cuerpo.cc_id_911[this.modelForm.id].v=this.modelForm.impuestoCalcColombia.toString();
    this.model.doc.cuerpo.cc_id_912[this.modelForm.id].v=this.modelForm.limitanteImpuestoExterior.toString();

  /*   this.model.doc.cuerpo.cc_id_564[this.modelForm.id].v=this.dutilidades.deshacerFormatoMoneda(this.modelForm.valDeclarar); */
  
  }

  public addToModeloDesdeForm(){
    let i=this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_904.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_905.push({it: i, v:this.modelForm.ubicacion.toString()});
    this.model.doc.cuerpo.cc_id_906.push({it: i, v:this.modelForm.valVenta.toString()});
    this.model.doc.cuerpo.cc_id_907.push({it: i, v:this.modelForm.anioCompra.toString()});
    this.model.doc.cuerpo.cc_id_908.push({it: i, v:this.modelForm.valCompra.toString()});
    this.model.doc.cuerpo.cc_id_909.push({it: i, v:this.modelForm.valMejoras.toString()});
    this.model.doc.cuerpo.cc_id_910.push({it: i, v:this.modelForm.valImpuestoPag.toString()});
    
    this.model.doc.cuerpo.cc_id_911.push({it: i, v:this.modelForm.impuestoCalcColombia.toString()});
    this.model.doc.cuerpo.cc_id_912.push({it: i, v:this.modelForm.limitanteImpuestoExterior.toString()});

 //   this.model.doc.cuerpo.cc_id_564.push({it: i, v:this.dutilidades.deshacerFormatoMoneda(this.modelForm.valDeclarar)});
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_904.splice(index,1);
    this.model.doc.cuerpo.cc_id_905.splice(index,1);
    this.model.doc.cuerpo.cc_id_906.splice(index,1);
    this.model.doc.cuerpo.cc_id_907.splice(index,1);
    this.model.doc.cuerpo.cc_id_908.splice(index,1);
    this.model.doc.cuerpo.cc_id_909.splice(index,1);
    this.model.doc.cuerpo.cc_id_910.splice(index,1);

    this.model.doc.cuerpo.cc_id_911.splice(index,1);
    this.model.doc.cuerpo.cc_id_912.splice(index,1);

    

    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_904.length;i++){
      this.model.doc.cuerpo.cc_id_904[i].it=i+1;
      this.model.doc.cuerpo.cc_id_905[i].it=i+1;
      this.model.doc.cuerpo.cc_id_906[i].it=i+1;
      this.model.doc.cuerpo.cc_id_907[i].it=i+1;
      this.model.doc.cuerpo.cc_id_908[i].it=i+1;
      this.model.doc.cuerpo.cc_id_909[i].it=i+1;
      this.model.doc.cuerpo.cc_id_910[i].it=i+1;

      this.model.doc.cuerpo.cc_id_911[i].it=i+1;
      this.model.doc.cuerpo.cc_id_912[i].it=i+1;

      


      
    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.desc==undefined || this.modelForm.desc=="" ||
    this.modelForm.valVenta==undefined || this.modelForm.valVenta=="0" ||
        this.modelForm.valCompra==undefined || this.modelForm.valCompra=="0" || 
        this.modelForm.anioCompra==undefined || this.modelForm.anioCompra=="0" ||
        this.modelForm.valImpuestoPag==undefined || 
        this.modelForm.ubicacion==undefined || this.modelForm.ubicacion==0 ||
         this.modelForm.valMejoras==undefined 


  }

  public redondearFormData(){
    this.modelForm.valVenta=this.dutilidades.redondearValorMoneda(this.modelForm.valVenta.toString(),true);
    this.modelForm.valCompra=this.dutilidades.redondearValorMoneda(this.modelForm.valCompra.toString(),true);
    this.modelForm.valImpuestoPag=this.dutilidades.redondearValorMoneda(this.modelForm.valImpuestoPag.toString(),true);
    this.modelForm.valMejoras=this.dutilidades.redondearValorMoneda(this.modelForm.valMejoras.toString(),true);

  }

  
  private convertirPesosUvt(valorPesos) {
    valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);

    let valorOperacion = new BigNumber210(valorPesos);

    valorOperacion = valorOperacion.div(this.UVT);

    valorOperacion = valorOperacion.toFormat();

    const punto = valorOperacion.indexOf(".") + 1;

    if (punto > 0 && valorOperacion.length - punto > 2)
      valorOperacion = valorOperacion.slice(0, -1);

    return String(valorOperacion);
  }

  protected operarCamposCuerpo(
    operacion: DTipoOperacionAritmetica,
    modelo: DDocumento,
    campos: Array<string>,
    formatear: boolean
  ): string {
    let valores = [];

    for (let i in campos) {
      if (this.dutilidades.validarValorNumerico(modelo.doc.cuerpo[campos[i]])) {
        let valor = this.dutilidades.redondearValorMoneda(
          modelo.doc.cuerpo[campos[i]]
        );

        valores.push(valor);

        //valores.push(modelo.doc.cuerpo[campos[i]]);
      } else {
        valores.push("0");
      }
    }

    return this.dutilidades.ejecutarOperacionMultipleValores(
      valores,
      operacion,
      formatear
    );
  }

  private aplicarTablaArt241ET(baseGravable, rangos) {
    let desde: boolean = false;

    let hasta: boolean = false;

    for (let i = 0; i < rangos.length; i++) {
      desde = this.dutilidades.validacionesNumericas(
        DTipoOperacionAritmetica.MAYOR_QUE,
        baseGravable,
        rangos[i].desde
      );

      if (i + 1 < rangos.length) {
        hasta = this.dutilidades.validacionesNumericas(
          DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,
          baseGravable,
          rangos[i + 1].desde
        );
      } else {
        hasta = true;
      }

      if (desde && hasta) {
        const resultadoResta = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.RESTA,
          baseGravable,
          rangos[i].desde
        );

        let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.MULTIPLICACION,
          resultadoResta,
          rangos[i].tarifa
        );

        const punto = resultadoMultiplicacion.indexOf(".");

        if (punto != -1) {
          resultadoMultiplicacion = resultadoMultiplicacion.substring(
            0,
            punto + 3
          );
        }

        const resultadoSuma2 = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.SUMA,
          resultadoMultiplicacion,
          rangos[i].impuesto
        );

        const resultadoOperacion = this.dutilidades.ejecutarOperacion(
          DTipoOperacionAritmetica.MULTIPLICACION,
          resultadoSuma2,
          this.UVT
        );

        return resultadoOperacion;
      }
    }

    return "0";
  }

  //UVT

  private obtenerValorPeriodico110(): void {
    this.dBasicosParametricasServicios
      .obtenerValorPeriodico(VAL_PERIODICO_110, ANNIODECLARACION)
      .subscribe(
        (data) => this.setObjectFromResponse(data),

        (error) => console.log(error)
      );
  }

  private setObjectFromResponse(data: any): void {
    let model = <DValorPeriodico>data;
    this.UVT = String(model.valor);
  }



  public calcularValoresForm(){
    //TODO Calculos 
    this.redondearFormData();

    //calculo impuesto calculado en colombia
    const cas906 = this.modelForm.valVenta;
    const cas908 = this.modelForm.valCompra;
    const cas909 = this.modelForm.valMejoras;

 
    let base1 = this.dutilidades.ejecutarOperacion(
      DTipoOperacionAritmetica.RESTA,
      cas906,
      cas908
    );
    base1 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,base1,"0")?"0":base1;

    let base2 = this.dutilidades.ejecutarOperacion(
      DTipoOperacionAritmetica.RESTA,
      base1,
      cas909
    );
    base2 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,base2,"0")?"0":base2;

    const valorEnUvt = this.convertirPesosUvt(base2);
    let resultado = this.aplicarTablaArt241ET(
      valorEnUvt,
      this.rangosArt241ET
    );
    resultado = this.dutilidades.redondearValorMoneda(resultado, true);

    this.modelForm.impuestoCalcColombia = resultado;

    //calculo limitante impuesto
    if(this.dutilidades.validacionesNumericas(
      DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,
      this.modelForm.valImpuestoPag.toString(),
      this.modelForm.impuestoCalcColombia
    )){
      this.modelForm.limitanteImpuestoExterior = this.modelForm.valImpuestoPag;
    }else{
      this.modelForm.limitanteImpuestoExterior = this.modelForm.impuestoCalcColombia;
    }
 
  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.editModeloDesdeForm();
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs488();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs488();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }


  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ 
      this.showSave=true 
    };
  }

  changeUbicacion(){
    if(this.modelForm.ubicacion == 1){
      this.modelForm.valImpuestoPag = "0";
    }

    this.calcularValoresForm();
  }
  
  
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-activos-modal/renta-no-laboral-activos-modal.component.ts